import { useLocation, Navigate } from "react-router-dom";
import NotFound from "./NotFound";
import { resolveRedirect } from "../lib/redirects";

// Catch-all wrapper: if a legacy Wix URL resolves, redirect. Otherwise 404.
export default function LegacyRoute() {
  const { pathname } = useLocation();
  const target = resolveRedirect(pathname);
  if (target) {
    return <Navigate to={target} replace />;
  }
  return <NotFound />;
}
